/*

Load bundles dynamically

const bundles = {
  LoginPage: import("views/LoginPage"),
  ActivityPage: import("views/ActivityPage"),
  HomePage: import("views/HomePage")
}

<BundleRegistry registry={bundles}>
  <Router>
    <div className="AppRoot">
      <Route
        exact
        path="/"
        render={() => {
          return <Redirect to="/login" />
        }}
      />
      <Route
        exact
        path="/login"
        render={({ match, location, history }) => {
          return (
            <div className="screen--full bg">
              <Bundle
                name="LoginPage"
                onLogin={() => {
                  history.push("/activity")
                }}
              />
            </div>
          )
        }}
      />
    </div>
  </Router>
</BundleRegistry>


<Bundle load={() => import('./something')}>
  {(Comp) => (Comp
    ? <Comp/>
    : <Loading/>
  )}
</Bundle>
*/

import React, { Component } from "react";
import PropTypes from "prop-types";

// const ___BundleRegistry = {
//   HomePage: import("views/HomePage"),
//   LoginPage: import("views/LoginPage")
// }

function getBundle(name, props) {
  return (
    <BundleLoader
      load={registry => {
        return registry[name]();
      }}
    >
      {Component => <Component {...props} />}
    </BundleLoader>
  );
}

export class BundleRegistry extends Component {
  getChildContext() {
    return {
      bundleRegistry: this.props.registry
    };
  }

  render() {
    return this.props.children;
  }
}

BundleRegistry.childContextTypes = {
  bundleRegistry: PropTypes.object
};

BundleRegistry.propTypes = {
  registry: PropTypes.object
};

BundleRegistry.defaultProps = {
  registry: {}
};

class BundleLoader extends Component {
  state = {
    // short for "module" but that's a keyword in js, so "mod"
    mod: null
  };

  componentWillMount() {
    this.load(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.load !== this.props.load) {
      //this.load(nextProps)
    }
  }

  load(props) {
    this.setState({
      mod: null
    });
    props.load(this.context.bundleRegistry).then(mod => {
      this.setState({
        // handle both es imports and cjs
        mod: mod.default ? mod.default : mod
      });
    });
  }

  render() {
    return this.state.mod ? this.props.children(this.state.mod) : null;
  }
}
BundleLoader.contextTypes = {
  bundleRegistry: PropTypes.object
};

export const Bundle = function({ name, ...props }) {
  return getBundle(name, props);
};



// WEBPACK FOOTER //
// ./src/components/Bundle/index.js